import React, {useMemo} from "react";
import MapContent from "./map-content.jsx";
import {useQuery} from "@tanstack/react-query";
import CorporationService from "../../../../../services/web/corporation-service.js";
import {APIProvider, ControlPosition, Map as GoogleMaps} from "@vis.gl/react-google-maps";

const ReportContent = ({ data, mapImage }) => {
    const coordinates = data?.coordinates ?? [];

    const { data: corporation } = useQuery({
        queryKey: ['corporation'],
        queryFn: () => CorporationService.entity(),
    });

    const position = useMemo(() => {
        if (coordinates.length >= 2) {
            return {
                lat: parseFloat(coordinates[0]),
                lng: parseFloat(coordinates[1]),
            };
        }

        return {lat: -23.0, lng: -46.0};
    }, [coordinates]);

    return (
        <>
            { corporation && !mapImage && (
                <div className="print:hidden relative">
                    <APIProvider apiKey={corporation?.maps_api_key ?? ""} language="pt-BR" libraries={["places"]}>
                        <GoogleMaps
                            id={'map-report-component'}
                            ref={(map) => {
                                if (map && map.map) {
                                    const div = map.map.getDiv();
                                    div.__google_map_instance = map.map;
                                }
                            }}
                            defaultZoom={18}
                            defaultCenter={position}
                            streetViewControl={false}
                            scrollwheel={true}
                            gestureHandling={'greedy'}
                            renderingType="RASTER"
                            style={{ height: "644px", width: "100%" }}
                            fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
                            mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                        >
                            <MapContent coordinates={coordinates}/>
                        </GoogleMaps>
                    </APIProvider>
                </div>
            )}
        </>
    );
};

export default ReportContent;